import { useEffect, useState } from 'react';
import { KeyValueEntity } from '../../../FrontEndReact/src/Core/Types/base';
import { User } from '../../../FrontEndReact/src/Core/Types/user';

declare global {
	interface Window {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		angular: any;
	}
}

export function getAngularJsService(name: string) {
	return window.angular.element(document.body).injector().get(name);
}

export function goto(state: string, params?: Record<string, string | number>) {
	const service = getAngularJsService('$state');
	service.go(state, params);
}

export function setDirtyLegacy(isDirty: boolean) {
	const service = getAngularJsService('admin.core.service');
	service.SetDirty(isDirty);
}

export function getLoggedInUser(): User {
	const rootScope = getAngularJsService('$rootScope');
	return rootScope.LoggedInUser as User;
}

export function getMiniSetting(module: string, key: string) {
	const rootScope = getAngularJsService('$rootScope');
	return rootScope.GetMiniSetting(module, key) as unknown;
}

export const getTranslations = async (phraseKeys: string[]): Promise<KeyValueEntity[]> => {
	const translate = getAngularJsService('$translate');
	const translations = await translate(phraseKeys);
	const res = phraseKeys.map((pk) => {
		return {
			Key: pk,
			Value: translations[pk].toString() !== pk ? translations[pk].toString() : null,
		} as KeyValueEntity;
	});
	return res;
};

export const getTranslation = async (phraseKey: string): Promise<string | undefined> => {
	const result = await getTranslations([phraseKey]);
	if (result && result.length > 0) return result[0].Value;
	return;
};

export const useGetTranslation = (phraseKey: string): string | undefined => {
	const [value, setValue] = useState<string | undefined>(undefined);
	useEffect(() => {
		getTranslation(phraseKey).then((res) => setValue(res));
	}, [phraseKey]);
	return value;
};

export const useGetTranslations = (phraseKeys: string[]): Record<string, string> => {
	const [value, setValue] = useState<Record<string, string>>({});
	useEffect(() => {
		getTranslations(phraseKeys).then((res) => setValue(res.reduce((acc, curr) => ({ ...acc, [curr.Key]: curr.Value }), {})));
	}, [phraseKeys]);
	return value;
};
